import translation from 'translation';
import AccountsListOnboarding from 'onboarding/onboardings/AccountsListOnboarding/accountsListOnboarding';
import AllAccountsOnboarding from 'onboarding/onboardings/AllAccountsOnboarding/allAccountsOnboarding';
import ConnectionsOnboarding from 'onboarding/onboardings/ConnectionsOnboarding/connectionsOnboarding';
import ProjectPlacementsOnboarding
  from 'onboarding/onboardings/ProjectPlacementsOnboarding/projectPlacementsOnboarding';
import ProjectsListCommonInfoOnboarding
  from 'onboarding/onboardings/ProjectsListCommonInfoOnboarding/projectsListCommonInfoOnboarding';
import ProjectsListDetailInfoOnboarding
  from 'onboarding/onboardings/ProjectsListDetailInfoOnboarding/projectsListDetailInfoOnboarding';

const referenceDictionary = function () {
  return {

    // menu routes
    segments: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/segments/?utm_source=marilyn_tools_help&utm_content=segments'
    },

    // accounts list
    accounts: {
      helpTitle: translation.tr('How does the account work?'),
      helpLink: '/reference/accounts/?utm_source=marilyn_tools_help&utm_content=accounts',
      onboarding: AllAccountsOnboarding
    },
    list: {
      helpTitle: translation.tr('How does the account work?'),
      helpLink: '/reference/accounts/?utm_source=marilyn_tools_help&utm_content=accounts',
      onboarding: AccountsListOnboarding
    },
    details: {
      helpTitle: translation.tr('How does the project work?'),
      helpLink: '/reference/projects',
      onboarding: ProjectsListDetailInfoOnboarding
    },
    bidmanager: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/bid-manager/?utm_source=marilyn_tools_help&utm_content=bid_manager'
    },
    balancing: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/balancing/?utm_source=marilyn_tools_help&utm_content=balancing'
    },
    syncGroups: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/sync/?utm_source=marilyn_tools_help&utm_content=sync'
    },
    urlcheck: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/urlcheck/?utm_source=marilyn_tools_help&utm_content=urlcheck'
    },
    crossminus: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/crossminus/?utm_source=marilyn_tools_help&utm_content=crossminus'
    },
    utmTagger: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/utm/?utm_source=marilyn_tools_help&utm_content=utm'
    },
    orders: {
      helpTitle: translation.tr('How does the tool work?'),
      helpLink: '/reference/orders/?utm_source=marilyn_tools_help&utm_content=orders'
    },
    placements: {
      helpTitle: translation.tr('How to work with placements?'),
      helpLink: '/reference/placements/?utm_source=marilyn_tools_help&utm_content=placements',
      onboarding: ProjectPlacementsOnboarding
    },
    placementCreate: {
      helpTitle: translation.tr('How to work with placements?'),
      helpLink: '/reference/placements/?utm_source=marilyn_tools_help&utm_content=placements_create',
      title: translation.tr('Add placement')
    },
    projects: {
      helpTitle: translation.tr('How does the project work?'),
      helpLink: '/reference/projects/?utm_source=marilyn_tools_help&utm_content=projects',
      onboarding: ProjectsListCommonInfoOnboarding
    },
    roles: {
      helpTitle: translation.tr('How does the roles work?'),
      helpLink: '/reference/roles/?utm_source=marilyn_tools_help&utm_content=roles'
    },
    connections: {
      helpTitle: translation.tr('What can be connected to the system?'),
      helpLink: '/reference/connections-main/?utm_source=marilyn_tools_help&utm_content=connections',
      onboarding: ConnectionsOnboarding
    },

    // creation routes (not from menu)
    connectionCreate: {
      helpTitle: translation.tr('How to connect the account?'),
      helpLink: '/reference/connections-platforms/?utm_source=marilyn_tools_help&utm_content=connections_platforms'
    },
    connectionCreatePendingSubconnection: {
      helpTitle: translation.tr('How to connect the account?'),
      helpLink: '/reference/connections-platforms/?utm_source=marilyn_tools_help&utm_content=connections_platforms'
    },
    webanalyticsConnectionCreate: {
      helpTitle: translation.tr('How to add web analytics and calltracking?'),
      helpLink: '/reference/connections-systems/?utm_source=marilyn_tools_help&utm_content=connections_systems'
    },
    userAccountAdd: {
      helpTitle: translation.tr('How does the roles work?'),
      helpLink: '/reference/roles/?utm_source=marilyn_tools_help&utm_content=roles_create'
    },
    accountCreate: {
      helpTitle: translation.tr('How does the account work?'),
      helpLink: '/reference/accounts/?utm_source=marilyn_tools_help&utm_content=accounts_create'
    },
    projectCreate: {
      helpTitle: translation.tr('How does the project work?'),
      helpLink: '/reference/projects/?utm_source=marilyn_tools_help&utm_content=projects_create'
    }
  };
};

const creationRouteNames = [
  'projectCreate',
  'placementCreate',
  'accountCreate',
  'userAccountAdd',
  'connectionCreate',
  'webanalyticsConnectionCreate'
];

export {creationRouteNames, referenceDictionary};
